import React, { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import Subscribe from '../Subscribe';
import * as s from './styles';
const FAQSection = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = () => {
    window.location.href =
      'https://docs.google.com/forms/d/e/1FAIpQLSdXvs8oON6UlCO-t-o0Rpje6qgXwFHcNd_jgWKC5BNd600H6g/viewform?pli=1';
  };

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <s.BtnMobile>
        <Subscribe onClick={handleClick}>Inscreva-se</Subscribe>
      </s.BtnMobile>
      <s.FAQContainer>
        <s.TextImage src='/assets/questions.svg' alt='Texto' />
        {faqs.map((faq, index) => (
          <s.FAQItem key={index}>
            <s.Question onClick={() => toggleFAQ(index)}>
              <s.QuestionText>{faq.question}</s.QuestionText>
              <s.Icon isActive={activeIndex === index}>
                <IoIosArrowDown />
              </s.Icon>
            </s.Question>
            {activeIndex === index && <s.Answer>{faq.answer}</s.Answer>}
          </s.FAQItem>
        ))}
      </s.FAQContainer>
    </>
  );
};

export default FAQSection;
